import { useContext } from 'react'
import { courseStore } from '../state/courseStore'
import { pageStore } from '../state/pagestore'
import { useHistory } from 'react-router-dom'
const useNextPage = ({ levelID, nextPage, onLastPage, link }) => {
  const { state: courseState, dispatch: courseDispatch } = useContext(courseStore)
  const { dispatch: pageDispatch } = useContext(pageStore)
  if (onLastPage && levelID.indexOf('l-') > -1) { // Only run on last page of a level
    if (courseState.levels.length === courseState.completedLevels + 1) {
      const currLevel = courseState.levels.find(level => level.id === levelID)
      if (currLevel.tasks.filter(task => !task.completed).length === 0) {
        link = '/completed-' + courseState.launchData.courseMode + '/page-1'
      }
    }
  }
  const nextPageLink = link || (onLastPage ? '/menu' : `/${levelID}/${nextPage}`)

  const history = useHistory()
  const handleContinue = () => {
    // Don't change state if we're on about page
    if (levelID.indexOf('l-') > -1) {
      if (onLastPage) {
        courseDispatch({
          type: 'completed-level',
          levelID,
          pageID: nextPage
        })
      } else {
        courseDispatch({
          type: 'next-module-page',
          levelID,
          pageID: nextPage
        })
      }
    }
    pageDispatch({
      type: 'toggle-skip',
      toggle: true
    })
    // Move on to next page
    history.push(nextPageLink)
    // Sroll to top afterwards, in case page has content beyond height viewport
    document.body.scrollTop = document.documentElement.scrollTop = 0
  }
  return [handleContinue, nextPageLink]
}

export default useNextPage
